<template>
    <div
        ref="widget-container"
        :class="$style.widget"
    />
</template>

<script setup lang="ts">
import { onMounted, onUnmounted, useTemplateRef } from 'vue'

import { useTurnstile } from './use-turnstile'

const emit = defineEmits<{
    tokenReceived: [token: string]
    error: []
}>()

const widgetContainer = useTemplateRef('widget-container')

const { render, remove } = useTurnstile({
    onSuccess: (token) => {
        emit('tokenReceived', token)
    },
    onError: () => {
        emit('error')
    },
})

onMounted(() => {
    render(widgetContainer)
})

onUnmounted(() => {
    remove()
})
</script>

<style module>
.widget {
    min-height: 65px;
}
</style>
